module.exports = "/_next/static/images/DeliveryDestinations@2x-b5575e7c8b7632cf3fabae17080b8ce1.webp";